var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',[_c('b-datepicker',{attrs:{"first-day-of-week":1,"range":"","size":"is-small"},model:{value:(_vm.dates),callback:function ($$v) {_vm.dates=$$v},expression:"dates"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }